import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { CreditCardRepository } from "../domain/CreditCardRepository";
import { CreditCard } from "../domain/CreditCard";

export function createApiCreditCardRepository(): CreditCardRepository {
  return new APICreditCardRepository();
}

export class APICreditCardRepository
  extends APIRepository
  implements CreditCardRepository {
  constructor() {
    super(vectiAppApiUrl());
  }



  async addCreditCardFile(myFile: File, companyId: string, month: string, year: string): Promise<VectiResult> {
    try {

      const formData = new FormData();
      formData.append('file', myFile);
      formData.append('companyId', companyId);
      formData.append('month', month);
      formData.append('year', year);

      formData.forEach((value, key) => {
        console.log("myFormData:" + key + " - " + value);
      });
      console.log("myFormData:" + JSON.stringify(formData));

      console.log("addCreditCardFile Repository X: " + companyId + "month: " + month + " ,year:" + year + ",myFile:" + myFile.name);


      const resp = await this.doPostFile<FormData, VectiResult>("/api/creditcards/processPDFFile", null,
        formData
      );
      console.log("addCreditCardFile resp:" + JSON.stringify(resp));
      return new VectiResult(true, resp);
    } catch (error) {
      console.log("error addCreditCardFile X:" + error);
      return new VectiResult(false, "Error: " + error);
    }
  }


  async saveCreditCard(companyId: string, card:any): Promise<VectiResult> {
    try {

      console.log("saveCreditCard Repository : " + companyId + " card: " + JSON.stringify(card));


       await this.doPostNew("/api/creditcards/addCreditCard", null, {
        ...card,        
        company_uid: companyId,
      });

      return new VectiResult(true,"tarjeta almacenada");
    } catch (error) {
      console.log("error addCreditCardFile X:" + error);
      return new VectiResult(false, "Error: " + error);
    }
  }


 async listCreditCardByCompany(companyId: string): Promise<VectiResult>{
    try {
      console.log("listCreditCardByCompany Repository : " + companyId);
     const ret = await this.doGet<CreditCard[]>("/api/creditcards/company/" + companyId.toString());
      return new VectiResult(true, ret);
    } catch (error) {
      console.log("error listCreditCardByCompany:" + error);
      return new VectiResult(false, "Error: " + error);
    }
  }


  }